
import { create } from "zustand";
import { devtools } from "zustand/middleware";





const storeApi = (set) => ({

    totalInventario: 0,
    activarInventario: null,


    setActivarInventario: (valor) => {
        set({ activarInventario: valor })
    },

});





export const useInventarioStore = create(
    devtools(
        storeApi
    )
)
